import { Component } from "@angular/core";

/**
 * Onglet message
 *
 * @author Yannick Gauthier
 * @date 03/06/2025
 */
@Component({
    selector: 'utilisateurs-message',
    host: {'data-test-id': 'utilisateurs-message'},
    templateUrl: './utilisateurs-message.component.html'
})
export class UtilisateursMessageComponent {}